import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { AuthservicesService } from 'src/app/services/authservices.service';
import { of } from "rxjs";
import {
  debounceTime,
  map,
  distinctUntilChanged,
  filter
} from "rxjs/operators";
import { Location } from '@angular/common';

import { fromEvent } from 'rxjs'; import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2'
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, ModalDismissReasons, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({

  selector: 'app-merchant-directory',
  templateUrl: './merchant-directory.component.html',
  styleUrls: ['./merchant-directory.component.css']
})
export class MerchantDirectoryComponent implements OnInit {
  @ViewChild('movieSearchInput', { static: true }) movieSearchInput: ElementRef;

  loading = false;
  objArr = []
  pageNo
  pageSize
  arrList
  totalItems
  arr
  details
  filterData
  constructor(private modalService: NgbModal, private authService: AuthservicesService, private router: Router, private route: ActivatedRoute, private location: Location) {
    this.pageSize = environment.pageSize
  }


  ngOnInit(): void {
    this.arr = environment.arr;

    this.route.queryParams.subscribe(params => {
      this.details = JSON.parse(JSON.stringify(params));
    });

    if (Object.keys(this.details).length == 0) {
      this.getClaimList(1)

    }
    else {
      this.onFilter(1)
    }



    // this.getClaimList(1)



    fromEvent(this.movieSearchInput.nativeElement, 'keyup').pipe(

      // get value
      map((event: any) => {

        return event.target.value;


      })
      // if character length greater then 2
      , filter(res => res.length > 2)

      , debounceTime(1000)

      // If previous query is diffent from current
      , distinctUntilChanged()

      // subscription for response
    ).subscribe((text: string) => {
      this.loading = false
      this.objArr = [];
      this.pageNo = event;
      let skip = 0
      this.authService.getMerchantdirectory(skip, this.pageSize, text).subscribe((res: any) => {
        console.log("res??????????", res)
        this.loading = true
        this.arrList = res.items
        this.totalItems = res.total
        this.arrList.forEach((e) => {
          let address = `${e.address.streetAddress},${e.address.city},${(e.address.stateName) ? e.address.stateName : e.address.state},${e.address.country}`
          this.objArr.push({
            id: (e._id) ? e._id : '',
            name: (e.name) ? e.name : '',
            description: (e.address.location) ? address : '',
            photo: (e.photo) ? this.renderImage(e.photo) : ''

          })
        })

      }, error => {
        this.loading = false;
        console.log(error)
      })

    });

  }
  onFilter(event) {
    this.loading = false
    this.objArr = [];
    this.arrList = []
    this.pageNo = event;
    let skip = this.pageSize * (event - 1);
    this.details['skip'] = skip
    this.details['limit'] = this.pageSize
    this.authService.onFilterMerchant(this.details).subscribe((res: any) => {
      this.loading = true
      this.filterData = res.items
      this.totalItems = res.total
      this.objArr = this.createArray(this.filterData)

      this.modalService.dismissAll();
    },

      error => {
        this.authService.successMessage(error.error.message, 'error')
        console.log(error)
      })
  }

  createArray(arr) {
    let obj = []
    arr.forEach((e) => {
      let address = `${e.address.streetAddress},${e.address.city},${(e.address.stateName) ? e.address.stateName : e.address.state},${e.address.country}`

      obj.push({
        id: (e._id) ? e._id : '',
        name: (e.name) ? e.name : '',
        description: (e.address.location) ? address : '',
        photo: (e.photo) ? this.renderImage(e.photo) : ''

      })
    })

    return obj
  }

  getClaimList(event) {
    this.loading = false
    this.objArr = [];
    this.pageNo = event;
    let skip = this.pageSize * (event - 1);
    this.authService.getMerchantdirectory(skip, this.pageSize, '').subscribe((res: any) => {
      this.loading = true
      this.arrList = res.data
      this.totalItems = res.total
      this.arrList.forEach((e) => {
        let address = `${e.address.streetAddress},${e.address.city},${(e.address.stateName) ? e.address.stateName : e.address.state},${e.address.country}`
        this.objArr.push({
          id: (e._id) ? e._id : '',
          name: (e.name) ? e.name : '',
          description: (e.address.location) ? address : '',
          photo: (e.photo) ? this.renderImage(e.photo) : '',
          isFounder : (e.isFounder) ? e.isFounder : false
        })
      })

    },
      error => {
        this.loading = false;
        console.log(error)
      })
  }

  getBlockMerchant(id) {
    let swall = this.authService.swal('block')
    swall.then((result) => {
      if (result.value == true) {
        this.authService.blockMerchant(id).subscribe((res: any) => {
          this.authService.successMessage(res.message, 'success')
          this.getClaimList(this.pageNo)
        },
          error => {
            this.authService.successMessage(error.error.message, 'error')
          })
      }
    })
  }

  getReportMerchant(id) {
    this.authService.reportMerchant(id).subscribe((res: any) => {
      this.authService.successMessage(res.message, 'success')
    },

      error => {
        this.authService.successMessage(error.error.message, 'error')

      })
  }

  renderImage(data) {
    return this.authService.spilturl(data)
  }

}

